import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Card, Dropdown, ListGroup } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import SimpleBar from 'simplebar-react';

const NotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      window.innerWidth < 1200 && setIsOpen(false);
    });
  }, []);

  return (
      <Dropdown navbar={true} as="li" show={isOpen} onToggle={handleToggle}>
        <Dropdown.Toggle
            bsPrefix="toggle"
            as={Link}
            to="#!"
            className={classNames('px-0 nav-link')}
        >
          <FontAwesomeIcon icon="bell" transform="shrink-6" className="fs-5" />
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-card dropdown-menu-end dropdown-caret dropdown-caret-bg">
          <Card
              className="dropdown-menu-notification dropdown-menu-end shadow-none"
              style={{ maxWidth: '20rem' }}
          >
            <FalconCardHeader
                className="card-header"
                title="Notifications"
                titleTag="h6"
                light={false}
            />
            <SimpleBar style={{ maxHeight: '19rem' }}>
              <ListGroup variant="flush" className="fw-normal fs-10">
                <div className="list-group-title">Nema novih notifikacija</div>
              </ListGroup>
            </SimpleBar>
            <div className="card-footer text-center border-top" onClick={handleToggle}>
              <Link className="card-link d-block" to="#!">
                View all
              </Link>
            </div>
          </Card>
        </Dropdown.Menu>
      </Dropdown>
  );
};

export default NotificationDropdown;